import Service from '../../Services/Service'

const ContactAPI = {
    sendMsgVenueHire(data) {
        return Service.post(`/customer-support/venue-hire`, {
            branch_id: data.branch_id,
            message: data.message,
            email: data.email,
            phone: data.phone
        });
    },
    sendMsgGroupVisit(data) {
        return Service.post(`/customer-support/group-visit`, {
            branch_id: data.branch_id,
            message: data.message,
            email: data.email,
            phone: data.phone,
            organization_name: data.organization_name
        });
    },
    sendMsgContactBranch(data) {
        return Service.post(`/customer-support/contact-branch`, {
            branch_id: data.branch_id,
            message: data.message,
            email: data.email,
            phone: data.phone
        });
    },
    getCategoryEnewsletter() {
        return Service.get(`/customer-support/newsletter-category`);
    },
    subscribeEnewsletter(data) {
        return Service.post(`/customer-support/subscribes`, {
            email: data.email,
            interested_in: data.interested
        });
    }
};

export default ContactAPI;
